import { useForm } from "@inertiajs/react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import FormField from "@/components/forms/FormField";

/**
 * Invites someone as a school admin without leaving the setup guide —
 * a co-organizer, or whoever holds the school's Square login. They get
 * a sign-in link by email, except on the free trial (invitesHeld), when
 * they're added without one (docs/BUSINESS_RULES.md §2a).
 */
export const INVITES_HELD_NOTE = "While you're on the free trial, we add them without emailing an invitation. They can sign in from the sign-in page with the email you enter.";

export default function InviteAdminForm({ path, submitLabel, invitesHeld = false }) {
  const label = submitLabel || (invitesHeld ? "Add them" : "Send invitation");
  const form = useForm({ name: "", email: "", role: "school_admin" });

  const submit = (e) => {
    e.preventDefault();
    form.post(path, { preserveScroll: true, onSuccess: () => form.reset("name", "email") });
  };

  return (
    <div className="space-y-3">
      <form onSubmit={submit} className="grid gap-3 sm:grid-cols-[1fr_1.3fr_auto] sm:items-end">
        <FormField
          name="invite_name"
          label="Their name"
          value={form.data.name}
          onChange={(e) => form.setData("name", e.target.value)}
          autoComplete="off"
        />
        <FormField
          name="invite_email"
          label="Their email"
          type="email"
          required
          value={form.data.email}
          onChange={(e) => form.setData("email", e.target.value)}
          autoComplete="off"
        />
        <Button type="submit" variant="outline" disabled={form.processing || !form.data.email}>
          <Send className="h-4 w-4" />
          {form.processing ? "Saving…" : label}
        </Button>
      </form>
      {invitesHeld && <p className="text-sm text-muted-foreground">{INVITES_HELD_NOTE}</p>}
    </div>
  );
}
